module.exports = __webpack_public_path__ + "media/images/bf-online-logo-uk-a95ae3b2977f1a659191108f854b8953.svg";